/* Wrap add to cart in the product page */
function wrapProductForm() {
  const inputElement = document.querySelector('.product-form__quantity');
  const formElement = document.querySelector('.product-form');

  if (inputElement && formElement) {
    if (!formElement.parentElement.classList.contains('add-to-cart-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'add-to-cart-wrapper';
      formElement.parentNode.insertBefore(wrapper, formElement);
      wrapper.appendChild(inputElement);
      wrapper.appendChild(formElement);
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  wrapProductForm();
});

const modalOpeners = document.querySelectorAll('.quick-add__submit');
modalOpeners.forEach(modalOpener => {
  modalOpener.addEventListener('click', () => {
    setTimeout(wrapProductForm, 300);
  });
});

/* Fancybox init */
Fancybox.bind("[data-fancybox='gallery']", {});

/* Collection read more */
(() => {
  function countWords(text) {
    const t = (text || '').trim()
    if (!t) return 0
    return t.split(/\s+/).length
  }

  function truncateElementToWords(el, limit) {
    if (!el || !limit || countWords(el.textContent) <= limit) return false

    const clone = el.cloneNode(true)
    let wordsLeft = limit
    let truncated = false

    function walk(node) {
      if (truncated) {
        node.remove()
        return
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const parts = node.nodeValue.split(/(\s+)/)
        let used = 0
        let out = ''

        for (const part of parts) {
          if (!part.trim()) {
            out += part
            continue
          }
          if (used < wordsLeft) {
            out += part
            used++
          } else break
        }

        if (used < parts.filter(p => p.trim()).length) {
          node.nodeValue = out.replace(/\s+$/, '') + '…'
          wordsLeft = 0
          truncated = true
        } else {
          wordsLeft -= used
        }
        return
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(walk)
        if (!node.textContent.trim() && !node.children.length) node.remove()
      }
    }

    walk(clone)

    el.innerHTML = ''
    while (clone.firstChild) el.appendChild(clone.firstChild)
    return true
  }

  document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('.js-readmore')
    if (!wrappers.length) return

    wrappers.forEach(wrapper => {
      if (!wrapper.dataset.limit) return

      const limit = parseInt(wrapper.dataset.limit, 10)
      if (!limit || limit < 1) return

      const content = wrapper.querySelector('.collection-long-description__content')
      const button = wrapper.querySelector('.collection-long-description__read-more')
      if (!content || !button) return

      const originalHTML = content.innerHTML
      if (!truncateElementToWords(content, limit)) return

      button.hidden = false
      button.addEventListener('click', () => {
        content.innerHTML = originalHTML
        button.remove()
      })
    })
  })
})()
/* Make homepage slideshow image clickable */
document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('slideshow-component .slideshow__slide');

  slides.forEach(function (slide) {
    slide.style.cursor = 'pointer';

    slide.addEventListener('click', function (event) {
      if (
        event.target.closest('a') ||
        event.target.closest('button') ||
        event.target.closest('.slider-button') ||
        event.target.closest('.slideshow__controls')
      ) {
        return;
      }

      window.location.href = '/collections/baldai-sandelyje';
    });
  });
});